__turbopack_context__.v({
  "expand_btn": "inlgEG_expand_btn",
  "list_block": "inlgEG_list_block",
  "richtext": "inlgEG_richtext",
});
